import date from 'quasar/src/utils/date.js';;
export default (function (val, format) {
  return date.formatDate(val, format);
});